import React from 'react';

const DeletedText = ({ children, deleted }) => (deleted ? <del>{children}</del> : children);

export default DeletedText;
